import type { Theme } from '@emotion/react';
import { css  } from '@emotion/react';

import { breakpoint } from '@twistopayments/design-system/styles';

import type { StepperVariant } from '../stepper';

export const container = (theme: Theme) => css`
  display: grid;
  position: relative;
  grid-auto-flow: row;
  min-height: ${theme.spacing[32]};

  ${breakpoint.up('sm')} {
    min-height: ${theme.spacing[40]};
  }
`;

export const alignment: Record<StepperVariant, ReturnType<typeof css>> = {
  vertical: css`
    align-items: center;
    justify-items: start;
  `,
  horizontal: css`
    align-items: start;
    justify-items: center;
  `,
};
